export default __webpack_public_path__ + "static/media/LetsGetStarted2.0a39a053.svg";